import React, { useState, useContext, useEffect } from 'react';
import { TextField, Button, Paper, Typography, Grid, IconButton, Box, Stack } from '@mui/material';

import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { updateClientPhotosAsync } from '../../../../api/Clients';
import { DataContext } from '../../../../context/DataContext';
import { getToken } from '../../../../api/Account';
import { simpleMessage } from '../../../../helpers/Helpers';

const ClientPhoto = ({ id, localReload, setLocalReload, setEditPhotos }) => {
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [previews, setPreviews] = useState([]);

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	// Limpiar URLs cuando el componente se desmonte
	useEffect(() => {
		return () => {
			previews.forEach((preview) => URL.revokeObjectURL(preview.preview));
		};
	}, []);

	const onChangeFile = (e) => {
		const files = Array.from(e.target.files);

		if (!files) return;

		if (files.length > 2) {
			simpleMessage('Solo puedes seleccionar máximo 2 archivos', 'error');
			e.target.value = ''; // Limpiar la selección
			return;
		}

		// Crear vistas previas
		const newPreviews = files.map((file) => ({
			file,
			preview: URL.createObjectURL(file)
		}));

		setSelectedFiles(files);
		setPreviews(newPreviews);
	};

	const saveFotos = async () => {
		if (validate()) {
			const formData = new FormData();

			formData.append('id', id);

			selectedFiles.forEach((photo, index) => {
				formData.append(`clientPhotos`, photo); // o photo si es directamente el File
			});

			setIsLoading(true);
			const result = await updateClientPhotosAsync(token, formData);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}

				simpleMessage(result.error, 'error');
				return;
			}

			setIsLoading(false);
			setLocalReload(!localReload);
			setEditPhotos(false);
			simpleMessage('Fotos Actualizadas...!', 'success');
		}
	};

	const validate = () => {
		let isValid = true;

		if (selectedFiles.length < 2) {
			simpleMessage('Debe seleccionar al menos dos fotos', 'error');
			return (isValid = false);
		}
		return isValid;
	};

	return (
		<div>
			<Box style={{ marginTop: 25 }}>
				<Grid container spacing={2}>
					<TextField
						fullWidth
						type="file"
						label="Fotos del Cliente"
						inputProps={{
							multiple: true,
							accept: 'image/*', // opcional: limitar a imágenes
							shrink: true
						}}
						onChange={onChangeFile}
					/>

					{previews.length > 0 && (
						<Box sx={{ mt: 2, mb: 2, width: '100%' }}>
							<Grid container spacing={2} justifyContent="space-between">
								{previews.map((preview, index) => (
									<Grid item xs={6} key={index}>
										<Paper
											sx={{
												position: 'relative',
												p: 1,
												height: 200,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center'
											}}
										>
											<img
												src={preview.preview}
												alt={`Vista previa ${index + 1}`}
												style={{
													maxWidth: '100%',
													maxHeight: '100%',
													objectFit: 'contain'
												}}
												onLoad={() => URL.revokeObjectURL(preview.preview)}
											/>
										</Paper>
										<Typography
											variant="caption"
											display="block"
											textAlign="center"
											sx={{ mt: 1 }}
										>
											{preview.file.name}
										</Typography>
									</Grid>
								))}
							</Grid>
						</Box>
					)}

					{/* {clientPhotos.map((preview, index) => {
						console.log('🚀 ~ preview:', preview.imageFullPath);
						return (
							<Grid item xs={6} key={index}>
								<Paper
									sx={{
										position: 'relative',
										p: 1,
										height: 200,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center'
									}}
								>
									<IconButton
										size="small"
										sx={{
											position: 'absolute',
											top: 8,
											right: 8,
											backgroundColor: '#f50057',
											'&:hover': {
												backgroundColor: '#f50057'
											},
											padding: 1
										}}
										onClick={() => deletePhoto(preview.id)} // Asegúrate de definir la función deletePhoto
									>
										<FontAwesomeIcon icon={faTrashAlt} />
									</IconButton>

									<img
										src={preview.imageFullPath}
										alt={`Vista previa ${index + 1}`}
										style={{
											maxWidth: '100%',
											maxHeight: '100%',
											objectFit: 'contain'
										}}
									/>
								</Paper>
							</Grid>
						);
					})} */}
				</Grid>

				<Button
					variant="outlined"
					startIcon={<FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />}
					fullWidth
					onClick={() => saveFotos()}
					style={{
						marginTop: 30,
						color: '#00a152',
						borderColor: '#00a152'
					}}
					size="large"
				>
					Actualizar Fotos
				</Button>
			</Box>
		</div>
	);
};

export default ClientPhoto;
